import { Card, List, Avatar, Space, Typography, Skeleton, Tag, Empty } from "antd";
import { TrophyOutlined, CrownOutlined, TrophyFilled, UserOutlined } from "@ant-design/icons";
import { COLORS } from "../../../utils/constant";

const { Text, Title } = Typography;

const TopPerformerItem = ({ performer, rank }) => {
  const getRankIcon = () => {
    if (rank === 1) return <CrownOutlined style={{ color: "#FFD700", fontSize: 24 }} />;
    if (rank === 2) return <TrophyFilled style={{ color: "#C0C0C0", fontSize: 24 }} />;
    if (rank === 3) return <TrophyFilled style={{ color: "#CD7F32", fontSize: 24 }} />;
    return <UserOutlined style={{ color: COLORS[rank % COLORS.length], fontSize: 20 }} />;
  };

  return (
    <List.Item>
      <List.Item.Meta
        avatar={
          <Space direction="vertical" align="center" size={0}>
            <Avatar
              size={48}
              icon={getRankIcon()}
              style={{
                backgroundColor: rank <= 3 ? "#fff" : COLORS[rank % COLORS.length],
                border: rank <= 3 ? "2px solid #d9d9d9" : "none",
              }}
            />
            <Text type="secondary" style={{ fontSize: 12 }}>
              #{rank}
            </Text>
          </Space>
        }
        title={
          <Space direction="vertical" size={0}>
            <Text strong>{performer.fullName}</Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {performer.designation}
              {performer.customDesignation && ` - ${performer.customDesignation}`}
            </Text>
          </Space>
        }
        description={
          <Space direction="vertical" size={4} style={{ width: "100%" }}>
            <Space split="|">
              <Text type="secondary" style={{ fontSize: 12 }}>
                {performer.hospital || "N/A"}
              </Text>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {performer.district || "N/A"}
              </Text>
            </Space>
            <Space size={4} wrap>
              <Tag color="blue">{performer.completedQuizzes} In Depth Learning</Tag>
              <Tag color="green">{performer.completedCases} Cases</Tag>
              <Tag color="orange">{performer.completedGuidelines} Guidelines</Tag>
            </Space>
          </Space>
        }
      />
      <div style={{ textAlign: "center" }}>
        <Title level={4} style={{ margin: 0, color: COLORS[0] }}>
          {performer.totalCpdPoints}
        </Title>
        <Text type="secondary" style={{ fontSize: 12 }}>
          CPD Points
        </Text>
      </div>
    </List.Item>
  );
};

const CpdTopPerformersPanel = ({ performers, loading }) => {
  return (
    <Card
      title={
        <Space>
          <TrophyOutlined style={{ color: "#FFD700", fontSize: 20 }} />
          <Title level={4} style={{ margin: 0 }}>
            Top Performers
          </Title>
        </Space>
      }
      style={{ height: "100%" }}
    >
      {loading ? (
        <Skeleton active paragraph={{ rows: 10 }} />
      ) : !performers || performers.length === 0 ? (
        <Empty description="No performers data available" />
      ) : (
        <List
          itemLayout="horizontal"
          dataSource={performers}
          renderItem={(performer, index) => (
            <TopPerformerItem performer={performer} rank={index + 1} />
          )}
          style={{ maxHeight: "600px", overflow: "auto" }}
        />
      )}
    </Card>
  );
};

export default CpdTopPerformersPanel;
